import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import PipelinesAPI from '../../api/pipelines';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getPipelines(_state) {
    return _state.records.sort((a, b) => a.id - b.id);
  },
  getActivePipelines(_state) {
    return _state.records.filter(
      record => record.is_active !== false && record.active !== false
    );
  },
  // Backward compat
  getFunnels(_state) {
    return _state.records.sort((a, b) => a.id - b.id);
  },
  getActiveFunnels(_state) {
    return _state.records.filter(
      record => record.is_active !== false && record.active !== false
    );
  },
};

export const actions = {
  get: async function getPipelines({ commit }) {
    commit(types.SET_PIPELINE_UI_FLAG, { isFetching: true });
    try {
      const response = await PipelinesAPI.get();
      commit(types.SET_PIPELINES, response.data.payload);
    } catch {
      // error silenced
    } finally {
      commit(types.SET_PIPELINE_UI_FLAG, { isFetching: false });
    }
  },
  create: async function createPipeline({ commit }, pipelineObj) {
    commit(types.SET_PIPELINE_UI_FLAG, { isCreating: true });
    try {
      const response = await PipelinesAPI.create(pipelineObj);
      commit(types.ADD_PIPELINE, response.data);
    } finally {
      commit(types.SET_PIPELINE_UI_FLAG, { isCreating: false });
    }
  },
  update: async ({ commit }, { id, ...updateObj }) => {
    commit(types.SET_PIPELINE_UI_FLAG, { isUpdating: true });
    try {
      const response = await PipelinesAPI.update(id, updateObj);
      commit(types.EDIT_PIPELINE, response.data);
    } finally {
      commit(types.SET_PIPELINE_UI_FLAG, { isUpdating: false });
    }
  },
  delete: async ({ commit }, id) => {
    commit(types.SET_PIPELINE_UI_FLAG, { isDeleting: true });
    try {
      await PipelinesAPI.delete(id);
      commit(types.DELETE_PIPELINE, id);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_PIPELINE_UI_FLAG, { isDeleting: false });
    }
  },
  resetStore({ commit }) {
    commit('RESET_PIPELINES_STORE');
  },
};

export const mutations = {
  [types.SET_PIPELINE_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  RESET_PIPELINES_STORE(_state) {
    _state.records = [];
    _state.uiFlags = {
      isFetching: false,
      isCreating: false,
      isUpdating: false,
      isDeleting: false,
    };
  },

  [types.ADD_PIPELINE]: MutationHelpers.create,
  [types.SET_PIPELINES]: MutationHelpers.set,
  [types.EDIT_PIPELINE]: MutationHelpers.update,
  [types.DELETE_PIPELINE]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
